<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">6</p>
        <p class="cabin-family bold">What is your level of knowledge and experience with investment
        products?</p>
      </div>

      <div class="literacy-body">
        <p class="">Please choose the options that reflect your knowledge and experience of
        investment products:</p>
      </div>

      <div class="table-responsive">
        <table class="table text-center">
          <thead>
            <th>Investment product</th>
            <th>None</th>
            <th>Limited <br> (1-3 Years)</th>
            <th>Experienced <br> (>3 Years)</th>
          </thead>
          <tbody>
            <tr>
              <td>Foreign Currency transactions</td>
              <td><input class="form-check-input" value="none" v-model="q6a"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6a"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6a"
                type="radio" id="radio1"></td>
            </tr>
             <tr>
              <td>Structured Products with Principal Protection</td>
              <td><input class="form-check-input" value="none" v-model="q6b"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6b"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6b"
                type="radio" id="radio1"></td>
            </tr>
            <tr>
              <td>Structured Products without Principal Protection</td>
              <td><input class="form-check-input" value="none" v-model="q6c"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6c"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6c"
                type="radio" id="radio1"></td>
            </tr>
            <tr>
              <td>Fixed Income (e.g. Bonds)</td>
              <td><input class="form-check-input" value="none" v-model="q6d"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6d"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6d"
                type="radio" id="radio1"></td>
            </tr>
            <tr>
              <td>Mutual Funds</td>
              <td><input class="form-check-input" value="none" v-model="q6e"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6e"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6e"
                type="radio" id="radio1"></td>
            </tr>
            <tr>
              <td>Individual Equities</td>
              <td><input class="form-check-input" value="none" v-model="q6f"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6f"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6f"
                type="radio" id="radio1"></td>
            </tr>
            <tr>
              <td>Derivatives, Options or Leverage</td>
              <td><input class="form-check-input" value="none" v-model="q6g"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="limited" v-model="q6g"
                type="radio" id="radio1"></td>
              <td><input class="form-check-input" value="experienced" v-model="q6g"
                type="radio" id="radio1"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="literacy-footer text-center">
        <button class="btn primary-btn btn-block" @click="next" >
        <span v-if="!loading">Complete Assessment</span>
        <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
        </vue-loaders-ball-spin-fade-loader>
        </button>
        <p class="cabin-family bold mt-2" @click="previous">Previous</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      q6a: '',
      q6b: '',
      q6c: '',
      q6d: '',
      q6e: '',
      q6f: '',
      q6g: '',
      loading: false,
    };
  },
  methods: {
    next() {
      this.loading = true;
      this.$emit('next', {
        q6a: this.q6a,
        q6b: this.q6b,
        q6c: this.q6c,
        q6d: this.q6d,
        q6e: this.q6e,
        q6f: this.q6f,
        q6g: this.q6g,
      });
    },
    previous() {
      this.$emit('previous');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.literacy-footer{
    position: relative;
    margin-top: 2rem;
    width: 100%;
}
.form-check-input{
  margin: 0;
}
.table th, .table td{
  vertical-align: middle;
  text-align: center;
}
td:first-child{
  text-align: justify;
}
</style>
